var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconWarningRed = function SvgIconWarningRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.333252C5.55967 0.333252 0.333008 5.55992 0.333008 11.9999C0.333008 18.4399 5.55967 23.6666 11.9997 23.6666C18.4397 23.6666 23.6663 18.4399 23.6663 11.9999C23.6663 5.55992 18.4397 0.333252 11.9997 0.333252ZM11.9997 13.1666C11.358 13.1666 10.833 12.6416 10.833 11.9999V7.33325C10.833 6.69159 11.358 6.16659 11.9997 6.16659C12.6413 6.16659 13.1663 6.69159 13.1663 7.33325V11.9999C13.1663 12.6416 12.6413 13.1666 11.9997 13.1666ZM13.1663 17.8333H10.833V15.4999H13.1663V17.8333Z",
    fill: "#E53D2F"
  })));
};

export default __webpack_public_path__ + "static/media/IconWarningRed.9fefce14.svg";
export { SvgIconWarningRed as ReactComponent };